// extracted by mini-css-extract-plugin
export var image = "sectionTestimonial-module--image--2e3db";
export var section = "sectionTestimonial-module--section--d7e31";
export var text = "sectionTestimonial-module--text--73adc";
export var white = "sectionTestimonial-module--white--4c6b0";